import React from 'react';
import { AlertDetailsList } from 'pages/Alerts/components/AlertsDetails/components/AlertDetailsList';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { ReactComponent as TuLogo } from 'style/_assets/icons/tu_logo.svg';
import { ReactComponent as EquifaxLogo } from 'style/_assets/icons/equifax-logo.svg';
import { ReactComponent as ExperianLogo } from 'style/_assets/icons/experian-logo.svg';
import { formatIncome } from 'helpers/money.helper';
import { useConfig } from 'hook/config.hook';

const bureauLogo = {
  TRANS_UNION: <TuLogo className="transunionLogo" />,
  EXPERIAN: <EquifaxLogo height={10} />,
  EQUIFAX: <ExperianLogo height={16} />,
};

const CreditLimitHeader = props => {
  const { config } = useConfig();
  const { selectedAlertDetails, alertDetailsConfig } = props;
  const overLimit = formatIncome(
    parseInt(selectedAlertDetails?.alertDetails?.accountBalance) -
      parseInt(selectedAlertDetails?.alertDetails?.creditLimit),
  );
  return (
    <FlexContainer
      className={'flex-column padL48 padR48 m-padL16 m-padR16 padB36'}
    >
      <Label
        type="H4"
        typeHeader={'h4'}
        className="text-28 fontLatoNormal700 margB16"
      >
        Credit Over Limit
      </Label>

      <Label className="caption fontGray300">
        {`Reported on ${props.alertDetailsConfig?.date} to `}
        {bureauLogo[props.selectedAlertDetails?.bureau]}
      </Label>
      <Label typeHeader={'h4'} className="H4 bold margT16 mH5">
        {`You are ${overLimit} over the credit limit on this card`}
      </Label>

      <Label className={'Body1 margT16 mBody-2'}>
        {config?.notificationAlerts?.creditOverLimit?.subtitle}
      </Label>

      <AlertDetailsList
        alertDetailsList={alertDetailsConfig?.alertDetailsList}
        lineType={alertDetailsConfig?.lineType}
        datatestid={`${props.datatestid}-detailList`}
        outerClass={'padB0 margT16'}
      />

      <Label typeHeader={'h4'} className="H4 margT16 mH5">
        {'How will this impact my credit score?'}
      </Label>
      <Label className="Body1 margT16 mBody-2">
        {config?.notificationAlerts?.creditOverLimit?.impactCredtiScoreDesc}
      </Label>
    </FlexContainer>
  );
};

export default CreditLimitHeader;
